import { render, staticRenderFns } from "./From.vue?vue&type=template&id=f83a902c&scoped=true&"
import script from "./From.vue?vue&type=script&lang=js&"
export * from "./From.vue?vue&type=script&lang=js&"
import style0 from "./From.vue?vue&type=style&index=0&id=f83a902c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83a902c",
  null
  
)

export default component.exports